var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H28C32.4183 0 36 3.58172 36 8V28C36 32.4183 32.4183 36 28 36H8C3.58172 36 0 32.4183 0 28V8Z",
    fill: "url(#paint0_linear_3467_4894)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91844 23.8761C11.447 26.669 14.9428 27.9785 17.4408 28.7174H17.4418C17.8054 28.8265 18.1947 28.8265 18.5583 28.7174C21.0562 27.9787 24.5531 26.6691 26.0806 23.8761C27.0559 22.095 27.2555 19.8207 27.3247 17.8351C27.3928 15.8496 27.3484 13.7827 27.3059 11.81V11.194H27.3069C27.2851 10.3353 26.7022 9.59166 25.8702 9.3598L18.5404 7.27511C18.1866 7.17392 17.8131 7.17392 17.4594 7.27511L10.1424 9.35488C9.31046 9.58574 8.72748 10.3304 8.70674 11.1891L8.69389 11.8227C8.6514 13.7905 8.60694 15.823 8.67512 17.8302C8.7433 19.8363 8.94416 22.092 9.91844 23.8761ZM10.0103 11.8562L10.0232 11.2226H10.0242C10.0281 10.9347 10.2238 10.6832 10.5034 10.6076L17.8183 8.53567V8.53469C17.9369 8.50325 18.0614 8.50325 18.179 8.53469L25.4959 10.6066L25.4969 10.6076C25.7765 10.6842 25.9712 10.9347 25.9761 11.2226V11.8385C26.0186 13.7926 26.063 15.8125 25.9968 17.791C25.9306 19.6252 25.7548 21.7079 24.9109 23.2503C23.6145 25.6081 20.4319 26.7899 18.1682 27.4629H18.1692C18.0506 27.4983 17.9241 27.4983 17.8056 27.4629C15.5319 26.7899 12.3592 25.6287 11.0628 23.2503C10.22 21.7069 10.0401 19.6242 9.97988 17.791C9.92455 15.8203 9.96901 13.8083 10.0115 11.8572L10.0103 11.8562Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5416 16.2987C23.7568 16.5734 23.7092 16.9711 23.4353 17.187L19.0204 20.6666C18.7482 20.8811 18.3545 20.8355 18.1382 20.5643L16.8769 18.9827C16.6593 18.7099 16.7034 18.3117 16.9754 18.0935C17.2473 17.8752 17.6442 17.9194 17.8618 18.1923L18.7327 19.2842L22.656 16.1921C22.9299 15.9762 23.3263 16.0239 23.5416 16.2987Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2865 14.1709C22.5017 14.4456 22.4541 14.8434 22.1802 15.0592L19.1843 17.4205C18.9121 17.635 18.5184 17.5894 18.3021 17.3182L17.4461 16.2449C17.2285 15.9721 17.2726 15.574 17.5446 15.3557C17.8166 15.1374 18.2135 15.1817 18.4311 15.4545L18.8965 16.0381L21.4009 14.0643C21.6748 13.8484 22.0713 13.8961 22.2865 14.1709Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2577 11.4469C12.6059 11.4383 12.8951 11.7146 12.9036 12.0638L13.081 19.3272C13.1337 21.4841 14.6151 23.3405 16.7016 23.8643C17.0395 23.9491 17.2449 24.2927 17.1603 24.6316C17.0758 24.9706 16.7333 25.1766 16.3954 25.0917C13.7586 24.4298 11.8866 22.0839 11.82 19.3582L11.6426 12.0948C11.6341 11.7455 11.9094 11.4554 12.2577 11.4469Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2291 11.4498L13.4732 11.4261C14.2662 11.411 14.9212 12.0437 14.9363 12.8391L14.9564 13.9044C14.9715 14.6999 14.3408 15.357 13.5478 15.3721L12.3037 15.3957L12.2291 11.4498Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.672 22.8406L14.3151 21.7721C14.7251 21.091 15.6078 20.8721 16.2869 21.2834L17.1961 21.834C17.8752 22.2452 18.0933 23.1308 17.6833 23.8119L17.0402 24.8804L13.672 22.8406Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3467_4894",
    x1: -0.0000011942,
    y1: 9,
    x2: 16.4975,
    y2: 40.1598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7960E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999734,
    stopColor: "#EE99AD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.849f167141cb8fc7f6f39533474db14a.svg";
export { ForwardRef as ReactComponent };